import React from 'react'
import { Button, Grid, Header, Icon, Segment } from 'semantic-ui-react'

const NotFound = ({ redirectUrl }) => {
  const backUrl = redirectUrl || (typeof Routes !== 'undefined' && Routes.compass_path ? Routes.compass_path() : '/')
  return (
    <div>
      <Grid verticalAlign="middle" textAlign="center" relaxed centered columns={1} className="min-height-90 full-height">
        <Grid.Column textAlign="center" tablet={10} mobile={16} computer={6}>
          <Segment>

            <Header icon>
              <Icon name="search" />
              {I18n.t('components.not_found.header')}
              <Header.Subheader>
                {I18n.t('components.not_found.subheader')}
              </Header.Subheader>
            </Header>

            <div style={{ marginTop: '1.5em' }}>
              <Button as="a" href={backUrl} color="green">
                {I18n.t('components.not_found.back_home')}
                <Icon name="angle double right" />
              </Button>
            </div>
          </Segment>
         </Grid.Column>
      </Grid>
    </div>
  )
}

export default NotFound
